export const HTTP_METHODS = {
  POST: "POST",
  PUT: "PUT",
};
